module.exports = __webpack_public_path__ + "216a4c9b3c02800821fc347cc6db73f9.jpg";